webpackJsonp([114276838955818,60335399758886],{

/***/ 155:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(290);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(155);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by BUCKLESCRIPT VERSION 3.0.0, PLEASE EDIT WITH CARE
	'use strict';
	
	var List = __webpack_require__(52);
	var Curry = __webpack_require__(17);
	var $$String = __webpack_require__(196);
	
	function make(classNames) {
	  return $$String.concat(" ", List.filter((function (className) {
	                      return className !== "";
	                    }))(classNames));
	}
	
	function ifBool(maybe, className) {
	  if (maybe) {
	    return className;
	  } else {
	    return "";
	  }
	}
	
	function ifOpt(maybe) {
	  if (maybe) {
	    return maybe[0];
	  } else {
	    return "";
	  }
	}
	
	function mapOpt(maybe, map) {
	  if (maybe) {
	    return Curry._1(map, maybe[0]);
	  } else {
	    return "";
	  }
	}
	
	exports.make = make;
	exports.ifBool = ifBool;
	exports.ifOpt = ifOpt;
	exports.mapOpt = mapOpt;
	/* No side effect */


/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by BUCKLESCRIPT VERSION 3.0.0, PLEASE EDIT WITH CARE
	'use strict';
	
	var ClassNames = __webpack_require__(553);
	
	var make = ClassNames.make;
	
	var ifBool = ClassNames.ifBool;
	
	var ifOpt = ClassNames.ifOpt;
	
	var mapOpt = ClassNames.mapOpt;
	
	exports.make = make;
	exports.ifBool = ifBool;
	exports.ifOpt = ifOpt;
	exports.mapOpt = mapOpt;
	/* No side effect */


/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cn = __webpack_require__(554);
	var ReasonReact = __webpack_require__(5);
	var ButtonModuleScss = __webpack_require__(445);
	
	var component = ReasonReact.statelessComponent("Button");
	
	function s(prim) {
	  return prim;
	}
	
	function make(_type, className, children) {
	  return (/* record */[
	    /* debugName */component[/* debugName */0],
	    /* reactClassInternal */component[/* reactClassInternal */1],
	    /* handedOffState */component[/* handedOffState */2],
	    /* willReceiveProps */component[/* willReceiveProps */3],
	    /* didMount */component[/* didMount */4],
	    /* didUpdate */component[/* didUpdate */5],
	    /* willUnmount */component[/* willUnmount */6],
	    /* willUpdate */component[/* willUpdate */7],
	    /* shouldUpdate */component[/* shouldUpdate */8],
	    /* render */function () {
	      var classNames = Cn.make( /* :: */[ButtonModuleScss.root,
	      /* :: */[Cn.ifOpt(className),
	      /* [] */0]]);
	      return ReasonReact.createDomElement("button", {
	        type: _type,
	        className: classNames
	      }, children);
	    },
	    /* initialState */component[/* initialState */10],
	    /* retainedProps */component[/* retainedProps */11],
	    /* reducer */component[/* reducer */12],
	    /* subscriptions */component[/* subscriptions */13],
	    /* jsElementWrapped */component[/* jsElementWrapped */14]]
	  );
	}
	
	exports.component = component;
	exports.s = s;
	exports.make = make;
	/* component Not a pure module */

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components----button-module---root---3SG0V"};

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Util = __webpack_require__(9);
	var React = __webpack_require__(1);
	var Gatsby = __webpack_require__(15);
	var Navigation = __webpack_require__(34);
	var ReasonReact = __webpack_require__(5);
	var FooterModuleScss = __webpack_require__(446);
	
	var component = ReasonReact.statelessComponent("Footer");
	
	var socialUrls = /* array */["https://twitter.com/reasonconf", "https://www.facebook.com/ReasonConf-1334078980027448/", "https://www.github.com/reasonvienna"];
	
	function organizerWithPic(param) {
	  var name = param[/* name */0];
	  return React.createElement("a", {
	    key: name,
	    className: FooterModuleScss.creator,
	    href: param[/* href */2]
	  }, React.createElement("img", {
	    className: FooterModuleScss.userpic,
	    alt: "Photo of " + (String(name) + ""),
	    src: param[/* imgUrl */1]
	  }), Util.s(name));
	}
	
	function make() {
	  return (/* record */[
	    /* debugName */component[/* debugName */0],
	    /* reactClassInternal */component[/* reactClassInternal */1],
	    /* handedOffState */component[/* handedOffState */2],
	    /* willReceiveProps */component[/* willReceiveProps */3],
	    /* didMount */component[/* didMount */4],
	    /* didUpdate */component[/* didUpdate */5],
	    /* willUnmount */component[/* willUnmount */6],
	    /* willUpdate */component[/* willUpdate */7],
	    /* shouldUpdate */component[/* shouldUpdate */8],
	    /* render */function () {
	      return React.createElement("footer", {
	        className: FooterModuleScss.root
	      }, React.createElement("div", {
	        className: "container_centered grid"
	      }, ReasonReact.element( /* None */0, /* None */0, Navigation.make("/", /* Some */[/* Footer */1], /* array */[])), React.createElement("nav", {
	        className: FooterModuleScss.additional
	      }, React.createElement("ul", undefined, React.createElement("li", undefined, ReasonReact.element( /* None */0, /* None */0, Gatsby.Link[/* make */0]("/coc/", /* None */0, /* None */0, /* None */0, /* array */[Util.s("Code of Conduct")]))), React.createElement("li", undefined, ReasonReact.element( /* None */0, /* None */0, Gatsby.Link[/* make */0]("/privacy/", /* None */0, /* None */0, /* None */0, /* array */[Util.s("Privacy Policy")]))), React.createElement("li", undefined, React.createElement("a", {
	        href: "/contact/"
	      }, Util.s("Contact Us"))), React.createElement("li", undefined, ReasonReact.element( /* None */0, /* None */0, Gatsby.Link[/* make */0]("/imprint/", /* None */0, /* None */0, /* None */0, /* array */[Util.s("Imprint")]))))), React.createElement("nav", {
	        className: FooterModuleScss.social
	      }, ReasonReact.element( /* None */0, /* None */0, Gatsby.SocialIcons[/* make */0](socialUrls, /* Some */[FooterModuleScss.socialIcon], /* Some */["#8eaeb6"], /* array */[]))), React.createElement("section", {
	        className: FooterModuleScss.copyright
	      }, Util.md("\nReasonConf is a [not-for-profit conference](/about/) event by ReasonVienna and ReactVienna communities.\n\nDesign by [Andrey Okonetchnikov](http://okonet.ru)\n\n© [ReasonConf](mailto:hi@reason-conf.com), 2018"))));
	    },
	    /* initialState */component[/* initialState */10],
	    /* retainedProps */component[/* retainedProps */11],
	    /* reducer */component[/* reducer */12],
	    /* subscriptions */component[/* subscriptions */13],
	    /* jsElementWrapped */component[/* jsElementWrapped */14]]
	  );
	}
	
	var Link = 0;
	
	var SocialIcons = 0;
	
	var SocialIcon = 0;
	
	exports.Link = Link;
	exports.SocialIcons = SocialIcons;
	exports.SocialIcon = SocialIcon;
	exports.component = component;
	exports.socialUrls = socialUrls;
	exports.organizerWithPic = organizerWithPic;
	exports.make = make;
	/* component Not a pure module */

/***/ }),

/***/ 446:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components----footer-module---root---oVj8I","socialIcon":"src-components----footer-module---socialIcon---A-Z9E","copyright":"src-components----footer-module---copyright---4FyNV"};

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Util = __webpack_require__(9);
	var React = __webpack_require__(1);
	var Gatsby = __webpack_require__(15);
	var ReasonReact = __webpack_require__(5);
	var LogoSvg = __webpack_require__(33);
	var NavigationModuleScss = __webpack_require__(60);
	
	var component = ReasonReact.statelessComponent("Navigation");
	
	function make(pathName, $staropt$star, _) {
	  var navigationLocation = $staropt$star ? $staropt$star[0] : /* Header */0;
	  return (/* record */[
	    /* debugName */component[/* debugName */0],
	    /* reactClassInternal */component[/* reactClassInternal */1],
	    /* handedOffState */component[/* handedOffState */2],
	    /* willReceiveProps */component[/* willReceiveProps */3],
	    /* didMount */component[/* didMount */4],
	    /* didUpdate */component[/* didUpdate */5],
	    /* willUnmount */component[/* willUnmount */6],
	    /* willUpdate */component[/* willUpdate */7],
	    /* shouldUpdate */component[/* shouldUpdate */8],
	    /* render */function () {
	      var isHomePage = pathName === "/";
	      var rootClassName = navigationLocation ? NavigationModuleScss.root_footer : NavigationModuleScss.root_header;
	      var match = navigationLocation === /* Header */0;
	      var activeClassName = match ? /* Some */[NavigationModuleScss.link_active] : /* None */0;
	      var match$1 = navigationLocation === /* Header */0;
	      var ticketsClassName = match$1 ? /* Some */[NavigationModuleScss.ticketsButton] : /* None */0;
	      var tmp = {
	        href: "https://ti.to/reason-conf/reason-conf-2018",
	        target: "_blank"
	      };
	      if (ticketsClassName) {
	        tmp.className = ticketsClassName[0];
	      }
	      return React.createElement("nav", {
	        className: rootClassName
	      }, Util.componentOrNull(!isHomePage, ReasonReact.element( /* None */0, /* None */0, Gatsby.Link[/* make */0]("/", /* Some */[NavigationModuleScss.link_home], /* None */0, /* None */0, /* array */[React.createElement("img", {
	        className: NavigationModuleScss.logo,
	        alt: "Home",
	        src: LogoSvg
	      })]))), React.createElement("ul", {
	        className: NavigationModuleScss.list
	      }, React.createElement("li", {
	        className: NavigationModuleScss.listItem
	      }, ReasonReact.element( /* None */0, /* None */0, Gatsby.Link[/* make */0]("/schedule/#day3", /* Some */[NavigationModuleScss.link], /* None */0, activeClassName, /* array */[Util.s("Schedule")]))), React.createElement("li", {
	        className: NavigationModuleScss.listItem
	      }, ReasonReact.element( /* None */0, /* None */0, Gatsby.Link[/* make */0]("/speakers/", /* Some */[NavigationModuleScss.link], /* None */0, activeClassName, /* array */[Util.s("Speakers")]))), React.createElement("li", {
	        className: NavigationModuleScss.listItem
	      }, ReasonReact.element( /* None */0, /* None */0, Gatsby.Link[/* make */0]("/attendees/", /* Some */[NavigationModuleScss.link], /* None */0, activeClassName, /* array */[Util.s("For Attendees")]))), React.createElement("li", {
	        className: NavigationModuleScss.listItem
	      }, ReasonReact.element( /* None */0, /* None */0, Gatsby.Link[/* make */0]("/sponsors/", /* Some */[NavigationModuleScss.link], /* None */0, activeClassName, /* array */[Util.s("For Sponsors")]))), React.createElement("li", {
	        className: NavigationModuleScss.listItem
	      }, ReasonReact.element( /* None */0, /* None */0, Gatsby.Link[/* make */0]("/jobs/", /* Some */[NavigationModuleScss.link], /* None */0, activeClassName, /* array */[Util.s("Jobs")]))), React.createElement("li", {
	        className: NavigationModuleScss.listItem
	      }, ReasonReact.element( /* None */0, /* None */0, Gatsby.Link[/* make */0]("/about/", /* Some */[NavigationModuleScss.link], /* None */0, activeClassName, /* array */[Util.s("About")]))), React.createElement("li", {
	        className: NavigationModuleScss.listItemBuy
	      }, React.createElement("a", tmp, Util.s("Buy a ticket")))));
	    },
	    /* initialState */component[/* initialState */10],
	    /* retainedProps */component[/* retainedProps */11],
	    /* reducer */component[/* reducer */12],
	    /* subscriptions */component[/* subscriptions */13],
	    /* jsElementWrapped */component[/* jsElementWrapped */14]]
	  );
	}
	
	var Link = 0;
	
	exports.Link = Link;
	exports.component = component;
	exports.make = make;
	/* component Not a pure module */

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components----navigation-module---root---3IAkn","link_active":"src-components----navigation-module---link_active---TqIvX","link_home":"src-components----navigation-module---link_home---1t4ac","logo":"src-components----navigation-module---logo---1T62g","root_header":"src-components----navigation-module---root_header---1V3f5 src-components----navigation-module---root---3IAkn","link":"src-components----navigation-module---link---2JAmB","list":"src-components----navigation-module---list---3zuve","listItem":"src-components----navigation-module---listItem---2-3Rr","listItemBuy":"src-components----navigation-module---listItemBuy---1FU1U src-components----navigation-module---listItem---2-3Rr","ticketsButton":"src-components----navigation-module---ticketsButton---9He-N src-components----button-module---root---3SG0V src-components----navigation-module---link---2JAmB","root_footer":"src-components----navigation-module---root_footer---2nzxu"};

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Util = __webpack_require__(9);
	var React = __webpack_require__(1);
	var Button = __webpack_require__(283);
	var ReasonReact = __webpack_require__(5);
	var SubscribeFormModuleScss = __webpack_require__(452);
	
	var component = ReasonReact.statelessComponent("SubscribeForm");
	
	function make() {
	  return (/* record */[
	    /* debugName */component[/* debugName */0],
	    /* reactClassInternal */component[/* reactClassInternal */1],
	    /* handedOffState */component[/* handedOffState */2],
	    /* willReceiveProps */component[/* willReceiveProps */3],
	    /* didMount */component[/* didMount */4],
	    /* didUpdate */component[/* didUpdate */5],
	    /* willUnmount */component[/* willUnmount */6],
	    /* willUpdate */component[/* willUpdate */7],
	    /* shouldUpdate */component[/* shouldUpdate */8],
	    /* render */function () {
	      return React.cloneElement(React.createElement("form", {
	        className: SubscribeFormModuleScss.root,
	        id: "mc-embedded-subscribe-form",
	        action: "https://reason-conf.us17.list-manage.com/subscribe/post?u=2ff99718c52457a4fa5219f66&amp;id=3e392893b9",
	        method: "post",
	        name: "mc-embedded-subscribe-form",
	        target: "_blank"
	      }, React.createElement("p", {
	        className: SubscribeFormModuleScss.text
	      }, Util.s("Get ReasonConf news straight to your inbox.")), React.createElement("p", {
	        className: SubscribeFormModuleScss.smallText
	      }, Util.md("We use MailChimp as newsletter tool. By subscribing you acknowledge that the information\n                you provide will be transferred to MailChimp for processing in accordance with their\n                [Privacy Policy](https://mailchimp.com/legal/privacy/) and [Terms](https://mailchimp.com/legal/terms/).\n            ")), React.createElement("div", {
	        className: SubscribeFormModuleScss.formRow
	      }, React.createElement("label", {
	        className: SubscribeFormModuleScss.label,
	        htmlFor: "email"
	      }, Util.s("Email")), React.createElement("input", {
	        className: SubscribeFormModuleScss.input,
	        id: "mce-EMAIL",
	        name: "EMAIL",
	        placeholder: "name@domain.com",
	        required: true,
	        type: "email"
	      }), React.createElement("div", {
	        className: SubscribeFormModuleScss.hiddenInput
	      }, React.createElement("input", {
	        tabIndex: -1,
	        name: "b_2ff99718c52457a4fa5219f66_3e392893b9",
	        type: "text"
	      })), ReasonReact.element( /* None */0, /* None */0, Button.make("submit", /* None */0, /* array */[Util.s("Subscribe")]))), React.createElement("input", {
	        name: "form-name",
	        type: "hidden",
	        value: "newsletter"
	      })), {
	        "data-netlify": true
	      });
	    },
	    /* initialState */component[/* initialState */10],
	    /* retainedProps */component[/* retainedProps */11],
	    /* reducer */component[/* reducer */12],
	    /* subscriptions */component[/* subscriptions */13],
	    /* jsElementWrapped */component[/* jsElementWrapped */14]]
	  );
	}
	
	var Link = 0;
	
	exports.Link = Link;
	exports.component = component;
	exports.make = make;
	/* component Not a pure module */

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components----subscribeForm-module---root---1N6AT","text":"src-components----subscribeForm-module---text---WcOSZ","smallText":"src-components----subscribeForm-module---smallText---18QhU","formRow":"src-components----subscribeForm-module---formRow---ufBoL","label":"src-components----subscribeForm-module---label---3UuUd","input":"src-components----subscribeForm-module---input---2ZyaL","hiddenInput":"src-components----subscribeForm-module---hiddenInput---2hMFs"};

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _layoutIndex = __webpack_require__(291);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_layoutIndex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Util = __webpack_require__(9);
	var Curry = __webpack_require__(17);
	var React = __webpack_require__(1);
	var Footer = __webpack_require__(284);
	var Gatsby = __webpack_require__(15);
	var Navigation = __webpack_require__(34);
	var ReasonReact = __webpack_require__(5);
	var SubscribeForm = __webpack_require__(289);
	
	__webpack_require__(458);
	
	__webpack_require__(548);
	
	var component = ReasonReact.statelessComponent("TemplateWrapper");
	
	var title = "ReasonConf 2018";
	
	function subscribeFormIfNeeded(hasSubscribeForm) {
	  return Util.componentOrNull(hasSubscribeForm, React.createElement("footer", {
	    className: "subscribe"
	  }, React.createElement("div", {
	    className: "container_centered grid grid_6cols"
	  }, React.createElement("h2", undefined, Util.s("Subscribe to Newsletter")), ReasonReact.element( /* None */0, /* None */0, SubscribeForm.make( /* array */[])))));
	}
	
	function make($$location, children) {
	  return (/* record */[
	    /* debugName */component[/* debugName */0],
	    /* reactClassInternal */component[/* reactClassInternal */1],
	    /* handedOffState */component[/* handedOffState */2],
	    /* willReceiveProps */component[/* willReceiveProps */3],
	    /* didMount */component[/* didMount */4],
	    /* didUpdate */component[/* didUpdate */5],
	    /* willUnmount */component[/* willUnmount */6],
	    /* willUpdate */component[/* willUpdate */7],
	    /* shouldUpdate */component[/* shouldUpdate */8],
	    /* render */function () {
	      var match = $$location.pathname;
	      var pageType;
	      switch (match) {
	        case "/":
	          pageType = /* Home */0;
	          break;
	        case "/badges":
	        case "/badges/":
	          pageType = /* Print */3;
	          break;
	        case "/speaker":
	        case "/speaker/":
	          pageType = /* NoLayout */2;
	          break;
	        default:
	          pageType = /* Normal */1;
	      }
	      var isThanksPage = $$location.pathname === "/thanks/";
	      switch (pageType) {
	        case 0:
	          return React.createElement("div", {
	            className: "page"
	          }, React.createElement("main", undefined, Curry._1(children, /* () */0)), subscribeFormIfNeeded(!isThanksPage), ReasonReact.element( /* None */0, /* None */0, Footer.make( /* array */[])));
	        case 1:
	          return React.createElement("div", {
	            className: "page"
	          }, ReasonReact.element( /* None */0, /* None */0, Gatsby.Helmet[/* make */0]( /* Some */[title], /* None */0, /* None */0, /* array */[])), React.createElement("div", {
	            className: "container container_centered"
	          }, React.createElement("header", undefined, ReasonReact.element( /* None */0, /* None */0, Navigation.make($$location.pathname, /* None */0, /* array */[]))), React.createElement("article", undefined, Curry._1(children, /* () */0))), subscribeFormIfNeeded(!isThanksPage), ReasonReact.element( /* None */0, /* None */0, Footer.make( /* array */[])));
	        case 2:
	          return React.createElement("div", undefined, ReasonReact.element( /* None */0, /* None */0, Gatsby.Helmet[/* make */0]( /* Some */[title], /* None */0, /* None */0, /* array */[])), Curry._1(children, /* () */0));
	        case 3:
	          return React.createElement("div", {
	            className: "page-print"
	          }, ReasonReact.element( /* None */0, /* None */0, Gatsby.Helmet[/* make */0]( /* Some */[title], /* Some */[{
	            class: "A4"
	          }], /* None */0, /* array */[React.createElement("link", {
	            href: "https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.3.0/paper.css",
	            rel: "stylesheet",
	            type: "text/css"
	          })])), Curry._1(children, /* () */0));
	
	      }
	    },
	    /* initialState */component[/* initialState */10],
	    /* retainedProps */component[/* retainedProps */11],
	    /* reducer */component[/* reducer */12],
	    /* subscriptions */component[/* subscriptions */13],
	    /* jsElementWrapped */component[/* jsElementWrapped */14]]
	  );
	}
	
	var $$default = ReasonReact.wrapReasonForJs(component, function (jsProps) {
	  return make(jsProps.location, jsProps.children);
	});
	
	var Helmet = 0;
	
	exports.Helmet = Helmet;
	exports.component = component;
	exports.title = title;
	exports.subscribeFormIfNeeded = subscribeFormIfNeeded;
	exports.make = make;
	exports.$$default = $$default;
	exports.default = $$default;
	exports.__esModule = true;
	/*  Not a pure module */

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-9a23d2f6dd133720f974.js